(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-mobile-nav], .nav-dropdown').forEach((details) => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      const summary = details.querySelector('summary');
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          summary.focus();
        }
      });
      details.addEventListener('click', (event) => {
        if (event.target.closest('a')) details.open = false;
      });
      document.addEventListener('click', (event) => {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    });
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const select = section.querySelector('[data-variant-select]');
      const button = section.querySelector('[data-add-button]');
      const quantity = section.querySelector('[data-quantity]');
      const gallery = section.querySelector('[data-gallery]');
      const moveToMedia = (mediaId) => {
        if (!mediaId || !gallery) return;
        const media = Array.from(gallery.querySelectorAll('[data-media-id]')).find((item) => item.dataset.mediaId === mediaId);
        if (media) gallery.scrollTo({ left: media.offsetLeft, behavior: 'auto' });
      };
      section.querySelectorAll('[data-media-link]').forEach((link) => link.addEventListener('click', (event) => {
        event.preventDefault();
        moveToMedia(link.dataset.mediaLink);
      }));
      if (!select || !button) return;
      const update = (setUrl) => {
        const variant = select.selectedOptions[0];
        if (!variant) return;
        const available = variant.dataset.available === 'true';
        const price = section.querySelector('[data-price]');
        const compare = section.querySelector('[data-compare-price]');
        const unit = section.querySelector('[data-unit-price]');
        if (price) price.textContent = variant.dataset.price;
        if (compare) {
          compare.textContent = variant.dataset.compare || '';
          compare.hidden = !variant.dataset.compare;
        }
        if (unit) {
          unit.textContent = variant.dataset.unit || '';
          unit.hidden = !variant.dataset.unit;
        }
        button.disabled = !available;
        section.querySelector('[data-add-text]').textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        const status = section.querySelector('[data-variant-status]');
        if (status) status.textContent = available ? '' : button.dataset.soldLabel;
        if (quantity) {
          const minimum = Number(variant.dataset.min) || 1;
          const increment = Number(variant.dataset.step) || 1;
          const maximum = Number(variant.dataset.max) || 0;
          quantity.min = minimum;
          quantity.step = increment;
          if (maximum) quantity.max = maximum;
          else quantity.removeAttribute('max');
          if (setUrl) quantity.value = minimum;
        }
        moveToMedia(variant.dataset.media);
        if (setUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.value);
          window.history.replaceState({}, '', url);
        }
      };
      select.addEventListener('change', () => update(true));
      requestAnimationFrame(() => update(false));
    });
    root.querySelectorAll('[data-print]').forEach((button) => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => window.print());
    });
    root.querySelectorAll('[data-gift-qr]').forEach((element) => {
      if (element.dataset.initialized || !window.QRCode) return;
      element.dataset.initialized = 'true';
      new window.QRCode(element, { text: element.dataset.identifier, width: 120, height: 120 });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
